import React, { useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import styled from 'styled-components';
import { RedButton } from '../Calculator/Calculator';
import { sendForm } from '@emailjs/browser';
import FormPopup from '../FormPopup/FormPopup';

const ContactForm = () => {
  const form = useRef<HTMLFormElement | null>(null);
  const [name, setName] = useState('');
  const [city, setCity] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [active, setActive] = useState(false);
  const [wrong, setWrong] = useState(false);
  const [loading, setLoading] = useState(false);

const getUMTParameter = () => {
  let searchString;
  const url = new URL(window.location.href);

  if(url.search.indexOf('&') !== -1) {
    searchString = url.search.slice(1).split('&');
  } else {
    searchString = url.search.slice(1).split('&amp')
  }
  return searchString;
}

  const utmParametersStr = getUMTParameter() || [];

  const sendMessage = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (name && city && email && phone && form.current) {
      setLoading(true);
      sendForm(
        'service_lj0qjjc',
        'template_0a2caip',
        form.current,
        '7J-KQTWKzbODChA92'
      )
        .then(
          (result) => {
            setLoading(false);
            yaCounter96693299.reachGoal("zayavka");
            setActive(true);
            setWrong(false);
          },
          (error) => {
            setActive(true);
            setWrong(false);
          }
        )
        .then(() => {
          form.current?.reset();
          setName('');
          setCity('');
          setEmail('');
          setPhone('');
        });
    } else {
      setActive(true);
      setWrong(true);
    }
  };

  const hiddenUTMFields = () => utmParametersStr?.map((umtValue) => {
    const separateUmtvalue: string[] = umtValue.split('=');
    const utmKey = separateUmtvalue[0];
    const utmValue = decodeURI(separateUmtvalue[1]);

    return (
      // eslint-disable-next-line react/jsx-key
      <ContactInput
        type="hidden"
        name={utmKey}
        key={`${utmKey}`}
        value={utmValue}
      />
    );
  })

  return (
    <>
      <ContactFormContainer>
        <Form onSubmit={sendMessage} ref={form}>
          <ContactBlock>
            <ContactLabel>ФИО</ContactLabel>
            <ContactInput
              type="text"
              placeholder="Введите ваше имя"
              name="name"
              className="shadow-none"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setName(e.target.value)
              }
            />
          </ContactBlock>
          <ContactBlock>
            <ContactLabel>Город</ContactLabel>
            <ContactInput
              type="text"
              placeholder="Введите город"
              name="city"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setCity(e.target.value)
              }
            />
          </ContactBlock>
          <ContactBlock>
            <ContactLabel>Телефон</ContactLabel>
            <ContactInput
              type="number"
              placeholder="+ 7 900 000-00-00"
              name="phone"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setPhone(e.target.value)
              }
            />
          </ContactBlock>
          <ContactBlock>
            <ContactLabel>Электронная почта</ContactLabel>
            <ContactInput
              type="email"
              placeholder="name@mail.ru"
              name="email"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setEmail(e.target.value)
              }
            />
          </ContactBlock>
          {utmParametersStr.length > 0 && hiddenUTMFields()}
          <ContactFooter>
            <ContactButton type="submit">Отправить заявку</ContactButton>
            <ContactFooterText>
              Нажимая на кнопку, вы даете согласие на обработку персональных
              данных и соглашаетесь с <u>Политикой конфиденциальности</u>
            </ContactFooterText>
          </ContactFooter>
        </Form>
      </ContactFormContainer>
      <FormPopup
        isActive={active}
        isWrong={wrong}
        setActive={setActive}
        isLoading={loading}
      />
    </>
  );
};

const ContactFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2.6rem;
`;

const ContactLabel = styled(Form.Label)`
  font-weight: 400;
  font-size: 20px;
  color: #606872;
  margin-bottom: 0.7rem;
`;

const ContactInput = styled(Form.Control)`
  background: #ffffff;
  border-radius: 8px;
  padding: 12px 16px 12px 24px;
  border: 2px solid transparent;
  font-size: 24px;
  outline: none;
  box-shadow: none;
  &:hover,
  &:focus {
    border: 2px solid #a2a8b0 !important;
    cursor: pointer;
    -webkit-box-shadow: none;
  }
`;

const ContactBlock = styled(Form.Group)`
  margin-bottom: 20px;
`;

const ContactFooter = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 599px) {
    flex-direction: column;
  }
`;

const ContactButton = styled(RedButton)`
  @media (max-width: 1440px) {
    width: 40%;
  }
  @media (max-width: 1135px) {
    width: 40%;
  }
  @media (max-width: 599px) {
    width: 100%;
  }
`;

const ContactFooterText = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: #606872;
  width: 57%;
  line-height: 20px;
  @media (max-width: 1135px) {
    margin-top: 0;
    margin-bottom: -15px;
    line-height: 21px;
  }
  @media (max-width: 730px) {
    width: 270px;
  }
  @media (max-width: 650px) {
    width: 210px;
  }
  @media (max-width: 599px) {
    width: 100%;
    margin-top: 1rem;
  }
`;

export default ContactForm;
